window.FontAwesomeConfig = {
    searchPseudoElements: true
}